import { clearCurrentUser, getCurrentUser } from '../lib/auth'

export async function apiFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const user = getCurrentUser()

  const headers: Record<string, string> = {}
  if (!(init?.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json'
  }
  if (user?.token) {
    headers['Authorization'] = `Bearer ${user.token}`
  }
  // Merge caller headers last so they can override
  if (init?.headers) {
    Object.assign(headers, init.headers as Record<string, string>)
  }

  const res = await fetch(`/api${path}`, { ...init, headers })

  if (res.status === 401) {
    clearCurrentUser()
    window.location.href = '/login'
    throw new Error('Unauthorized')
  }

  const data = (await res.json()) as T & { error?: string }
  if (!res.ok) throw new Error(data.error ?? 'Anfrage fehlgeschlagen')
  return data
}
